export const TagColorsExtended = {
  NEUTRAL: 'neutral',
} as const;
